import { CalendarClock, Check, FileText, GitBranch, Mail, MessageSquareReply, Pencil, Reply, Smartphone, Tag, X } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";

export const AI_META = {
  reply_email: { icon: Reply, color: "#7c3aed" }, followup_email: { icon: Mail, color: "#2563eb" }, reply_sms: { icon: Smartphone, color: "#0891b2" },
  reminder: { icon: CalendarClock, color: "#0d9488" }, change_step: { icon: GitBranch, color: "#ca8a04" }, quote: { icon: FileText, color: "#e8603c" }, add_tag: { icon: Tag, color: "#db2777" },
};
const EDITABLE = { reply_email: [["to", "Destinataire"], ["subject", "Objet"], ["body", "Message", true]], followup_email: [["to", "Destinataire"], ["subject", "Objet"], ["body", "Message", true]], reply_sms: [["text", "SMS", true]], reminder: [["date", "Date"], ["note", "Note", true]], add_tag: [["tag", "Tag"]] };

const Preview = ({ p }) => {
  const c = p.content;
  if (p.type.endsWith("email")) return <div className="ai-preview"><small>À : {c.to} · Objet : {c.subject}</small><pre>{c.body}</pre></div>;
  if (p.type === "reply_sms") return <div className="ai-preview"><pre>{c.text}</pre></div>;
  if (p.type === "reminder") return <div className="ai-preview"><small>Rappel le {new Date(c.date).toLocaleDateString("fr-FR")}</small>{c.note && <pre>{c.note}</pre>}</div>;
  if (p.type === "change_step") return <div className="ai-preview"><small>Nouvelle étape : <b>{c.step_name}</b></small></div>;
  if (p.type === "add_tag") return <div className="ai-preview"><small>Tag : <b>{c.tag}</b></small></div>;
  return <div className="ai-preview"><small>Brouillon de devis créé à partir du dossier existant, à relire avant envoi.</small></div>;
};

const Editor = ({ p, draft, setDraft }) => (
  <div className="ai-editor">
    {(EDITABLE[p.type] || []).map(([k, label, long]) => (
      <label key={k}>{label}{long ? <textarea rows={k === "body" ? 7 : 3} value={draft[k] || ""} onChange={(e) => setDraft({ ...draft, [k]: e.target.value })} data-testid={`ai-edit-${k}-${p.id}`} /> : <input type={k === "date" ? "date" : "text"} value={draft[k] || ""} onChange={(e) => setDraft({ ...draft, [k]: e.target.value })} data-testid={`ai-edit-${k}-${p.id}`} />}</label>
    ))}
  </div>
);

// Une proposition de la file « À valider »
export const AiActionItem = ({ p, label, checked, onCheck, onValidate, onIgnore, busy }) => {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(p.content);
  const [ignoring, setIgnoring] = useState(false);
  const [reason, setReason] = useState("");
  const m = AI_META[p.type] || AI_META.quote;
  const Icon = m.icon;
  return (
    <article className={`ai-item prio-${p.priority}`} style={{ "--c": m.color }} data-testid={`ai-item-${p.id}`}>
      <input type="checkbox" checked={checked} onChange={onCheck} data-testid={`ai-check-${p.id}`} />
      <div className="ai-body">
        <header>
          <span className="ck-type"><Icon size={14} /></span><strong>{label}</strong>
          <b className="ai-prio" data-testid={`ai-prio-${p.id}`}>{p.priority}</b>{p.demo && <b className="ai-demo">démo</b>}
          <Link to={`/pipeline?lead=${p.fiche_id}`} className="ai-fiche" data-testid={`ai-fiche-${p.id}`}>{p.title || `Fiche ${p.fiche_id}`}</Link>
          <span className="ck-muted">{p.owner_name || ""}</span>
        </header>
        <p className="ai-reason"><MessageSquareReply size={13} /> {p.reason}</p>
        {editing ? <Editor p={p} draft={draft} setDraft={setDraft} /> : <Preview p={p} />}
        {ignoring && <div className="ai-ignore"><input placeholder="Motif (facultatif)" value={reason} onChange={(e) => setReason(e.target.value)} data-testid={`ai-ignore-reason-${p.id}`} /><button type="button" className="secondary-button" disabled={busy} onClick={() => onIgnore(reason)} data-testid={`ai-ignore-confirm-${p.id}`}>Confirmer</button></div>}
        <footer>
          <button type="button" className="primary-button" disabled={busy} onClick={() => onValidate(editing ? draft : null)} data-testid={`ai-validate-${p.id}`}><Check size={14} /> Valider</button>
          {EDITABLE[p.type] && <button type="button" className="secondary-button" onClick={() => setEditing(!editing)} data-testid={`ai-edit-${p.id}`}><Pencil size={14} /> {editing ? "Aperçu" : "Modifier"}</button>}
          <button type="button" className="secondary-button" onClick={() => setIgnoring(!ignoring)} data-testid={`ai-ignore-${p.id}`}><X size={14} /> Ignorer</button>
        </footer>
      </div>
    </article>
  );
};
